import { ReasonInput } from '@strata/react-compound-inputs';
import { DialogWithForm } from '@strata/react-dialog';
import { SuccessToast } from '@strata/react-toast-message';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';

import { submitReferral } from 'api/clientAPI';
import { handleError } from 'services/Error';
import { fetchReferralDetails } from 'store/referrals/referralsSlice';

const Title = 'Submit Referral';

const ReasonOptions = ['Incorrect information', 'Restratification'];

export const SubmitReferralDialog = ({
    isOpen,
    onClose,
    referralDetails = undefined,
    username,
}) => {
    const dispatch = useDispatch();
    const { referralId, payerId } = referralDetails ?? {};
    return (
        <Formik
            initialValues={{}}
            enableReinitialize
            validateOnMount
            validationSchema={Yup.object({
                ...ReasonInput.validationSchema,
            })}
            onSubmit={async (values, { resetForm }) => {
                try {
                    await submitReferral({
                        referralId,
                        payerId,
                        username,
                        ...ReasonInput.submitValues(values),
                    });

                    await dispatch(fetchReferralDetails({ payerId, referralId }));

                    SuccessToast({ message: 'Referral submitted successfully.' });
                    resetForm();
                    onClose();
                } catch (err) {
                    handleError('Unable to submit referral. Please try again.', err);
                }
            }}
        >
            {(formik) => (
                <DialogWithForm
                    dialogTitle={Title}
                    width={560}
                    isOpen={isOpen}
                    secondaryButtonLabel="Cancel"
                    onSecondaryButtonClick={() => {
                        onClose();
                        formik.resetForm();
                    }}
                    primaryButtonLabel="Submit Referral"
                    isPrimaryButtonDisabled={!formik.isValid || formik.isSubmitting}
                    dialogContent={
                        <>
                            <div className="margin__bottom--medium">
                                This action mimics submitting the auth from the payer to our
                                platform.
                            </div>
                            <ReasonInput reasons={ReasonOptions} />
                        </>
                    }
                />
            )}
        </Formik>
    );
};

SubmitReferralDialog.Title = Title;

SubmitReferralDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    referralDetails: PropTypes.shape({
        referralId: PropTypes.string.isRequired,
        payerId: PropTypes.string.isRequired,
    }),
    username: PropTypes.string.isRequired,
};
